import { styled } from '@mui/material/styles';

export const TopHeaderContainer = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',

  marginBottom: '3rem',
});

export const TitleContainer = styled('div')(({ theme }) => ({
  color: theme.colors.base01,
}));

export const BodyContainer = styled('div')({
  height: '100%',

  display: 'flex',
  flexDirection: 'column',

  rowGap: '3rem',

  overflow: 'auto',
});

export const VotingProposalContainer = styled('div')({
  maxHeight: '43.5%',

  display: 'flex',
  flexDirection: 'column',
});

export const Wrapper = styled('div')({
  width: '100%',
  height: '100%',
  display: 'flex',

  overflow: 'auto',
});

type FinshedProposalContainerProps = {
  'data-is-restricted': boolean;
};

export const FinishedProposalContainer = styled('div')<FinshedProposalContainerProps>(({ ...props }) => ({
  width: '100%',
  maxHeight: props['data-is-restricted'] ? '84%' : 'calc(100% - 6rem)',

  display: 'flex',
  flexDirection: 'column',
}));

export const ProposalTitleContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',

  padding: '0 1.2rem',

  marginBottom: '1.2rem',

  color: theme.colors.base01,
}));

export const ProposalButtonContainer = styled('div')({
  height: '100%',

  display: 'flex',
  flexDirection: 'column',

  rowGap: '1.2rem',

  overflow: 'auto',
});

export const Base02TextContainer = styled('div')(({ theme }) => ({
  color: theme.colors.base02,
}));

type WrapperContainerProps = {
  'data-is-open': boolean;
};

export const WrapperContainer = styled('div')<WrapperContainerProps>((props) => ({
  position: 'absolute',
  left: '0',
  right: '0',
  top: '0',
  bottom: '0',

  display: props['data-is-open'] ? 'flex' : 'none',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: '1',
  overflowY: 'auto',

  backgroundColor: 'rgba(0, 0, 0, 0.6)',

  borderRadius: '2rem',
}));
